// MB-I18N-2A — auth EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "auth.phone_label": "Phone Number",
  "auth.phone_placeholder": "5XX XX XX XX",
  "auth.continue": "Continue",
  "auth.sms_notice": "We'll send you a verification code via SMS",
  "auth.otp_sent": "OTP sent!",
  "auth.enter_code": "Enter the code sent to",
  "auth.verify": "Verify",
  "auth.change_number": "Change phone number",
  "auth.dev_otp": "Dev Mode OTP",
  "auth.welcome": "Welcome!",
  "auth.setup_account": "Let's set up your account",
  "auth.your_name": "Your Name",
  "auth.enter_name": "Enter your first name",
  "auth.get_started": "Get Started",
  "auth.welcome_offer": "🎁 Welcome offer: Get 1 free coffee after spending 1,000 DA!",
  "auth.invalid_otp": "Invalid OTP",
  "auth.registration_failed": "Registration failed",
  "auth.welcome_to": "Welcome to SUPERKAWA®!",
  "auth.invalid_number": "Please enter a valid number",
  "auth.otp_send_failed": "Failed to send code",
  "auth.enter_6_digit": "Please enter the 6-digit code",
  "auth.enter_first_name": "Please enter your first name",
  "auth.staff_access": "Staff access",
  "auth.rewards_order": "Rewards & Order",

  // MB-I18N-AUTH — LoginPage (staff + platform)
  "auth.staff_back_marketing": "Back to superkawa.co",
  "auth.staff_footer": "Operational platform for independent food & beverage businesses · © Superkawa 2026",
  "auth.staff_title": "SUPERKAWA OS",
  "auth.staff_platform_title": "SUPERKAWA Platform",
  "auth.staff_subtitle": "Sign in to your workspace",
  "auth.staff_platform_subtitle": "Network space · Super-Admin access",
  "auth.staff_identifier_label": "Username",
  "auth.staff_identifier_placeholder": "e.g. Taha01",
  "auth.staff_password_label": "Password",
  "auth.staff_password_show": "Show password",
  "auth.staff_password_hide": "Hide password",
  "auth.staff_forgot_password": "Forgot password?",
  "auth.staff_submit": "Sign in",
  "auth.staff_or": "or",
  "auth.staff_register_cta": "Create my business",
  "auth.staff_not_partner": "Not a SUPERKAWA partner yet?",
  "auth.staff_discover": "Discover our solutions →",
  "auth.staff_go_establishment": "Business workspace login",
  "auth.staff_err_missing": "Please enter your email and password",
  "auth.staff_err_platform_only": "Access restricted to the SUPERKAWA platform.",
  "auth.staff_err_too_many": "Too many attempts. Please try again later.",
  "auth.staff_err_blocked": "Login blocked.",
  "auth.staff_err_invalid": "Incorrect credentials",
  "auth.staff_forgot_toast": "Contact your Superkawa representative to reset your password.",

  // MB-I18N-AUTH — RegisterPage
  "auth.register_title": "Create my business",
  "auth.register_subtitle": "Your business will be ready in under a minute.",
  "auth.register_guarantee_trial": "14-day free trial",
  "auth.register_guarantee_no_card": "No credit card",
  "auth.register_guarantee_ready": "Your shop ready in minutes",
  "auth.register_step_account": "Create your account",
  "auth.register_step_email": "Verify your email",
  "auth.register_step_config": "Set up your shop",
  "auth.register_name_label": "Owner name",
  "auth.register_name_placeholder": "Karim Benali",
  "auth.register_email_label": "Email",
  "auth.register_email_placeholder": "contact@your-business.com",
  "auth.register_shop_label": "Business name",
  "auth.register_shop_placeholder": "Le Petit Kawa",
  "auth.register_password_label": "Password",
  "auth.register_password_placeholder": "8 characters minimum",
  "auth.register_submit": "Create my business",
  "auth.register_reassurance": "14-day free trial · no credit card · your shop ready in minutes",
  "auth.register_have_account": "Already have an account?",
  "auth.register_login_link": "Sign in",
  "auth.register_err_missing": "Please fill in all fields",
  "auth.register_err_password_short": "Password must be at least 8 characters",
  "auth.register_err_email_used": "This email address is already in use",
  "auth.register_err_too_many": "Too many sign-ups. Please try again later.",
  "auth.register_err_invalid": "Please check the information entered",
  "auth.register_err_generic": "Something went wrong. Please try again.",
  "auth.register_success_title": "Verify your email address",
  "auth.register_success_sent_to": "A confirmation email has been sent to",
  "auth.register_success_access_1": "Access to your SUPERKAWA OS workspace will be available",
  "auth.register_success_access_highlight": "after verification",
  "auth.register_dev_mode": "Development mode",
  "auth.register_dev_notice": "Resend is not connected yet. Use this button to simulate clicking the email link.",
  "auth.register_dev_verify": "Test verification",
  "auth.register_already_verified": "Already verified?",

  // MB-I18N-BACKEND-2A — coded backend error messages (backward-compatible)
  "auth.errors.invalid_credentials": "Incorrect credentials",
  "auth.errors.email_not_verified": "Please verify your email address before signing in.",
  "auth.errors.register_name_required": "Name is required",
  "auth.errors.register_email_invalid": "Invalid email address",
  "auth.errors.register_password_too_short": "Password must be at least 8 characters",
  "auth.errors.register_email_exists": "This email address is already in use",
  "auth.errors.verify_token_missing": "Invalid verification link: missing token.",
  "auth.errors.verify_token_invalid": "This link is invalid or has expired.",
  "auth.errors.verify_token_expired": "This verification link has expired.",
};
